import * as React from "react";
import { Table, TableBody, TableCell, TableRow } from "../widget";
import DataGridBodyRow from "./DataGridBodyRow";
import { BodyColumn, HeaderColumn, DataGridLines, DataGridPadding } from "./Types";
import { ColGroup } from "./DataGridHeader";
import DataError from "./DataError";


const DataEmpty = function (props: { colSpan: number, loading: boolean, noItemsContent?: React.ReactNode }) {
    return <TableRow>
        <TableCell className="text-center" colSpan={props.colSpan}>{props.loading ? null : props.noItemsContent || <i>{"- seznam je prázdný -"}</i>}</TableCell>
    </TableRow>;
}

export interface DataGridBodyProps<T> {
    columns: BodyColumn<T>[];
    rows?: T[];
    loading: boolean;
    hasError: boolean;
    errorMsg: string;
    scrollX: (x: number) => void;
    headerRows: HeaderColumn[][];
    fixedHeight: boolean;
    gridLines?: DataGridLines;
    padding?: DataGridPadding;
    noItemsContent?: React.ReactNode;
    onClickRow?: (row: T) => void;
    //  width?: number;
    //  minWidth?: number;
    //  height?: number;
    //  minHeight?: number;
}


declare type Props<T> = DataGridBodyProps<T>;


class DataGridBody<T> extends React.PureComponent<Props<T>> {

    render() {

        const { columns, fixedHeight, gridLines, rows, padding, headerRows, noItemsContent, loading, onClickRow } = this.props;

        const outerStyle: React.CSSProperties = {
            overflowX: 'auto',//'hidden' as 'hidden',
            overflowY: fixedHeight === true ? 'scroll' : 'auto',
            //height: height || 'auto',
            flexGrow: 1,
            marginBottom: -1,
        }

        const innerStyle = {
            //overflow: 'auto'
            //            overflowY: 'auto' as 'auto',
            //          overflowX: 'auto' as 'auto',
        }

        const tableStyle: React.CSSProperties = {
            tableLayout: 'fixed',
            //  minWidth: this.props.minWidth ? this.props.minWidth : 'auto',
        }

        const onScroll = (e: any) => {
            //console.log("SCROLL: ", e.target.scrollLeft, e.target.scrollTop);
            // console.log("SCROLL: ", e, this);
            this.props.scrollX(e.target.scrollLeft);
        }
        return <div style={outerStyle} onScroll={onScroll}>

            <div style={innerStyle} >
                <Table style={tableStyle}>
                    <ColGroup headerRows={headerRows} />
                    <TableBody>
                        {
                            this.props.hasError ? <DataError message={this.props.errorMsg} colSpan={columns.length} />
                                : (rows && rows.length > 0)
                                    ? rows.map((row, k) => <DataGridBodyRow key={k} columns={columns} row={row} gridLines={gridLines} lastRow={k === rows.length - 1} padding={padding} onClickRow={onClickRow} />)
                                    : <DataEmpty colSpan={columns.length} noItemsContent={noItemsContent} loading={loading} />
                        }
                    </TableBody>
                </Table>
            </div>
        </div>
    }
}


export default DataGridBody;